import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authApiService } from '../../../../redux-manager';

export const useActions = () => {
  const dispatch = useDispatch();

  return bindActionCreators(authApiService, dispatch);
};
